<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <!-- <a [routerLink]="['/dashboard']" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/img/rammisbank.png" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/img/rammisbank.png" alt="" height="20">
          </span>
        </a>

        <a [routerLink]="['/dashboard']" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/img/rammisbank.png" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/img/rammisbank.png" alt="" height="20">
          </span>
        </a> -->
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
        id="vertical-menu-btn" (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

    </div>
    <h1 style="color: #E4AA25; font-weight: bold;">GBB USSD Banking</h1>
    <div class="d-flex">

    

   
    
      <div class="dropdown d-inline-block" ngbDropdown >
       <button type="button" class="btn header-item waves-effect" ngbDropdownToggle id="page-header-user-dropdown">
    <i style="color: #E4AA25; font-weight: bold;">   Welcome,
      <span class="d-none d-xl-inline-block ms-1 fw-medium font-size-15">{{account.firstName}}</span></i>
          <i class="uil-angle-down d-none d-xl-inline-block font-size-15"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a   [routerLink]="['/settings','profile',account?.id]" class="dropdown-item" href="javascript: void(0);">
            <i class="uil uil-user-circle font-size-18 align-middle text-muted me-1"></i>
            <span class="align-middle">{{ 'HEADER.LOGIN.PROFILE' | translate}}</span>
          </a>
          <a   [routerLink]="['/settings','changepassword',account?.id]" class="dropdown-item" href="javascript: void(0);">
            <i class="uil uil-user-circle font-size-18 align-middle text-muted me-1"></i>
            <span class="align-middle">{{ 'HEADER.LOGIN.CHANGEPASSWORD' | translate}}</span>
          </a>
       
          <a class="dropdown-item" href="javascript: void(0);" (click)="logout()">
            <i class="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"></i>
            <span class="align-middle">{{ 'HEADER.LOGIN.LOGOUT' | translate}}</span>
          </a>
        </div>
      </div>

    </div>
  </div>
</header>